import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { createConversation } from 'app/modules/conversation/api'
import { currentUser } from 'app/modules/user/selectors'
import * as EmbedSelectors from 'app/modules/embed/selectors'
import { disableNewMessageComposer } from 'app/modules/gates/selectors'

import './style.styl'

const LIVE_VIEW_TAG = 'Live View'

class StartConversationModal extends Component {
  state = {
    message: '',
    sent: false,
    sending: false,
  }

  handleChange = e => {
    this.setState({ message: e.target.value })
  }

  sendMessage = e => {
    e.preventDefault()
    this.setState({ sending: true }, this.handleSendClick)
  }

  handleSendClick = () => {
    this.props.listenForMessageSent(this.props.userId)

    const messageCopyDelay = () => setTimeout(() => this.setState({ sent: false }), 15000)

    const message = {
      body: this.state.message,
      status: 'CLOSED',
      orgId: this.props.currentUser.orgId,
      authorId: this.props.currentUser.id,
      inboxId: this.props.defaultInboxId,
      authorType: 'USER',
      attributes: {
        liveViewInitiated: true,
      },
      tags: [LIVE_VIEW_TAG],
      to: {
        id: this.props.userId,
        type: this.props.userType,
      },
    }

    createConversation(message).then(resp => {
      this.setState(
        {
          message: '',
          sentConversationLink: `/inboxes/${resp.inboxId}/conversations/${resp.conversationId}`,
          sent: true,
          sending: false,
        },
        messageCopyDelay
      )
    })
  }

  render() {
    const sentCopy = this.state.sent ? 'Sent!' : 'Send Message'
    const { isConversationDisabled } = this.props
    return (
      <div>
        <div className="lite-contact-send-message">
          {this.state.sent && (
            <div className="lite-contact-message-sent">
              <strong>Your message was sent!</strong>
              <Link className="drift-button drift-button-primary" to={this.state.sentConversationLink}>
                View conversation
              </Link>
            </div>
          )}
          {!this.state.sent && (
            <form className="drift-form" onSubmit={this.sendMessage}>
              <div>
                <fieldset>
                  <textarea
                    disabled={isConversationDisabled}
                    placeholder="Hey! How’s the weather over there?"
                    required
                    autoFocus
                    value={this.state.message}
                    onChange={this.handleChange}
                  />
                </fieldset>
              </div>
              {this.state.sending && <strong>Sending Message...</strong>}
              {!this.state.sending && (
                <button
                  className="drift-button drift-button-primary"
                  type="submit"
                  disabled={isConversationDisabled}
                >
                  {sentCopy}
                </button>
              )}
            </form>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentUser: currentUser(state),
    isConversationDisabled: disableNewMessageComposer(state),
    defaultInboxId: EmbedSelectors.defaultInboxId(state),
  }
}

const mapDispatchToProps = () => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StartConversationModal)



// WEBPACK FOOTER //
// ./src/scripts/components/shared/ContactRecordLite/StartConversation/index.js